// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__3A7FI","modal":"Modal_modal__3P-qa","animate_popup":"Modal_animate_popup__3WSUK","popup":"Modal_popup__1KxEP","center":"Modal_center__1k1hf"};